import { route, subGroup, professionalMeta } from '@/helpers/routes'
import DashboardSecretary from './gadget/index'

const routes = [
  route('index', '/index', DashboardSecretary, professionalMeta('Dashboard Secretaria', true, 'guest'))
]

export default subGroup('/dashboard', routes)



// WEBPACK FOOTER //
// ./src/app/employee/dashboard/routes.js